import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import NavBar from "../../Componentes/NavBar";
import SortableTable from "../../Componentes/Utils/SortableTable";
import { useModal } from "../../contexts/ModalContext";
import SidebarInventarioTI from "./SidebarInventarioTI";
import ModalNovoEquipamento from "./ModalNovoEquipamento";
import ModalAtribuirResponsavel from "./ModalAtribuirResponsavel";
import ModalNovoTipoAtivo from "./ModalNovoTipoAtivo";
import ModalOnboardColaborador from "./ModalOnboardColaborador";
import ModalOffboardColaborador from "./ModalOffboardColaborador";
import ModalGerarTermos from "./ModalGerarTermos";
import ModalDetalhesEquipamento from "./ModalDetalhesEquipamento";
import useApi from "../../hooks/useApi";

const formatDataBR = (value) => {
  if (value == null || value === "") return "—";
  const str = String(value).trim();
  if (!str) return "—";

  const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    return `${d}/${m}/${y}`;
  }

  const brMatch = str.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (brMatch) {
    const [, d, m, y] = brMatch;
    return `${d}/${m}/${y}`;
  }

  const date = new Date(str);
  if (!Number.isNaN(date.getTime())) {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  return str;
};

const INVENTARIO_API = {
  listaTabela: "/Painel/API/InventarioTI/GetAtivos/",
  tipos: "/Painel/API/InventarioTI/GetTiposAtivo/",
  criarAtivo: "/Painel/API/InventarioTI/CreateAtivo/",
  editarAtivo: "/Painel/API/InventarioTI/EditarAtivo/",
  desativarAtivo: "/Painel/API/InventarioTI/DesativarAtivo/",
  atribuir: "/Painel/API/InventarioTI/SaveResponsavel/",
  remover: "/Painel/API/InventarioTI/RemoveResponsavel/",
  criarTipo: "/Painel/API/InventarioTI/CreateTipoAtivo/",
};

const Container = styled.div`
  width: 100%;
  height: 100dvh;
  background-color: #242d34;
  display: flex;
  flex-direction: column;
`;

const BodyWrapper = styled.div`
  width: 100%;
  flex: 1;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 12px;
`;

const HeaderBar = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
`;

const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 16px;
  letter-spacing: 0.5px;
`;

const Badge = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
`;

const FilterGroup = styled.div`
  display: inline-flex;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
  height: 40px;
  box-sizing: border-box;
`;

const FilterButton = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  min-width: 90px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: ${(p) => (p.$active ? "#242d34" : "rgba(255,255,255,0.85)")};
  background: ${(p) => (p.$active ? "#ffffff" : "transparent")};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${(p) => (p.$active ? "#ffffff" : "rgba(255,255,255,0.08)")};
  }

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

const FilterInput = styled.input`
  height: 40px;
  flex: 1;
  min-width: 240px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  padding: 0 12px;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  &:focus {
    border-color: rgba(0, 123, 255, 0.9);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const TableShell = styled.div`
  width: 100%;
  flex: 1;
  background-color: #ffffff;
  border-radius: 15px;
  overflow: hidden;
`;

const ActionsCell = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const KebabButton = styled.button`
  all: unset;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #242d34;

  &:hover {
    background: rgba(36, 45, 52, 0.08);
  }

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 38px;
  right: 0;
  width: 220px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.18);
  border-radius: 12px;
  overflow: hidden;
  z-index: 10;
`;

const MenuItem = styled.button`
  all: unset;
  display: flex;
  width: 100%;
  padding: 12px 12px;
  box-sizing: border-box;
  cursor: pointer;
  color: #242d34;
  font-size: 13px;

  &:hover {
    background: #e8f0fe;
  }
`;

const DangerItem = styled(MenuItem)`
  color: #b91c1c;
  &:hover {
    background: rgba(185, 28, 28, 0.08);
  }
`;

export default function InventarioTI() {
  const { openModal, isModalOpen, closeModal } = useModal();
  const api = useApi();

  const [loading, setLoading] = useState(true);
  const [tiposAtivo, setTiposAtivo] = useState([]);
  /** Linhas retornadas pelo GET (id, descricao, patrimonio, num_serie, tipo, matricula, data_inicio) */
  const [rowsTabela, setRowsTabela] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [q, setQ] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  /** "em_uso" (padrão) mostra apenas equipamentos com responsável; "todos" mostra todos */
  const [filtroUso, setFiltroUso] = useState("em_uso");

  const menuRef = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (!openMenuId) return;
      if (menuRef.current && menuRef.current.contains(e.target)) return;
      setOpenMenuId(null);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [openMenuId]);

  const requestDados = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(INVENTARIO_API.listaTabela);
      const list = Array.isArray(data) ? data : data?.data ?? data?.rows ?? [];
      setRowsTabela(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Erro ao carregar inventário.");
    } finally {
      setLoading(false);
    }
  };

  const requestTiposAtivo = async () => {
    try {
      const { data } = await api.get(INVENTARIO_API.tipos);
      const tipos = Array.isArray(data) ? data : data?.data ?? [];
      setTiposAtivo(Array.isArray(tipos) ? tipos : []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    requestDados();
    requestTiposAtivo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const equipamentos = useMemo(() => {
    return (rowsTabela ?? []).map((r) => {
      const id = String(r.id ?? "");
      const numSerie = r.num_serie ?? r.numSerie ?? "";
      const matricula =
        r.matricula != null && String(r.matricula).trim() !== ""
          ? String(r.matricula).trim()
          : "";
      const nome = r.nome != null && String(r.nome).trim() !== "" ? String(r.nome).trim() : "";
      const funcao =
        r.funcao != null && String(r.funcao).trim() !== "" ? String(r.funcao).trim() : "";
      const centroCusto =
        r.centro_custo_desc != null && String(r.centro_custo_desc).trim() !== ""
          ? String(r.centro_custo_desc).trim()
          : r.centro_custo != null && String(r.centro_custo).trim() !== ""
          ? String(r.centro_custo).trim()
          : "";
      const observacoes =
        r.observacoes != null && String(r.observacoes).trim() !== ""
          ? String(r.observacoes).trim()
          : "";
      return {
        id,
        tipo: r.tipo ?? "—",
        descricao: r.descricao ?? "—",
        patrimonio: r.patrimonio ?? "—",
        serial: numSerie ? String(numSerie) : "—",
        observacoes: observacoes || "—",
        responsavel: matricula || "—",
        nome: nome || "—",
        funcao: funcao || "—",
        centro_custo: centroCusto || "—",
        data_inicio: r.data_inicio ?? r.dataInicio ?? null,
        data_inicio_label: formatDataBR(r.data_inicio ?? r.dataInicio),
        _raw: r,
      };
    });
  }, [rowsTabela]);

  const selectedEquipamento = useMemo(
    () => equipamentos.find((e) => e.id === selectedId) ?? null,
    [equipamentos, selectedId]
  );

  const filtered = useMemo(() => {
    const query = q.trim().toUpperCase();
    const base =
      filtroUso === "em_uso"
        ? equipamentos.filter((e) => e.responsavel !== "—")
        : equipamentos;
    if (!query) return base;
    return base.filter((e) => {
      const hay = [
        e.id,
        e.tipo,
        e.descricao,
        e.patrimonio,
        e.serial,
        e.observacoes,
        e.responsavel,
        e.nome,
        e.funcao,
        e.centro_custo,
        e.data_inicio_label,
      ]
        .filter(Boolean)
        .join(" ")
        .toUpperCase();
      return hay.includes(query);
    });
  }, [equipamentos, q, filtroUso]);

  const totalEmUso = useMemo(
    () => filtered.filter((e) => e.responsavel !== "—").length,
    [filtered]
  );

  const totalFiltrado = filtered.length;

  const handleOpenSidebar = () => openModal("sidebarInventarioTI");

  const handleRemoveResponsavel = async (equipamentoId) => {
    try {
      await api.post(INVENTARIO_API.remover, { id_ativo: equipamentoId });
      await requestDados();
      setSelectedId(equipamentoId);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erro ao remover responsável do equipamento.");
    }
  };

  const handleDesativar = async (equipamentoId) => {
    try {
      await api.post(INVENTARIO_API.desativarAtivo, { id_ativo: equipamentoId });
      await requestDados();
      setSelectedId(null);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erro ao desativar equipamento.");
    }
  };

  const [equipamentoIdParaResponsavel, setEquipamentoIdParaResponsavel] = useState("");
  const [equipamentoParaEditar, setEquipamentoParaEditar] = useState(null);

  const columns = useMemo(
    () => [
      { id: "id", header: "ID", accessor: (r) => r.id, width: "90px" },
      { id: "tipo", header: "TIPO", accessor: (r) => r.tipo, width: "120px" },
      { id: "descricao", header: "EQUIPAMENTO", accessor: (r) => r.descricao, width: "320px" },
      { id: "patrimonio", header: "PATRIMÔNIO", accessor: (r) => r.patrimonio, width: "130px" },
      { id: "serial", header: "Nº SÉRIE", accessor: (r) => r.serial, width: "140px" },
      { id: "observacoes", header: "OBSERVAÇÕES", accessor: (r) => r.observacoes, width: "260px" },
      { id: "responsavel", header: "MATRÍCULA", accessor: (r) => r.responsavel, width: "110px" },
      { id: "nome", header: "NOME", accessor: (r) => r.nome, width: "220px" },
      { id: "funcao", header: "FUNÇÃO", accessor: (r) => r.funcao, width: "200px" },
      { id: "centro_custo", header: "CENTRO DE CUSTO", accessor: (r) => r.centro_custo, width: "200px" },
      {
        id: "data_inicio",
        header: "DATA INÍCIO",
        accessor: (r) => r.data_inicio_label,
        sortValue: (r) => r.data_inicio ?? "",
        width: "130px",
      },
      {
        id: "acoes",
        header: "",
        accessor: () => null,
        sortable: false,
        width: "60px",
        align: "center",
        render: (_v, row) => (
          <ActionsCell
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <KebabButton
              type="button"
              title="Ações"
              aria-label={`Ações do equipamento ${row.id}`}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedId(row.id);
                setOpenMenuId((prev) => (prev === row.id ? null : row.id));
              }}
            >
              ⋯
            </KebabButton>

            {openMenuId === row.id && (
              <Menu
                ref={menuRef}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <MenuItem
                  type="button"
                  onClick={() => {
                    setOpenMenuId(null);
                    setEquipamentoParaEditar(row);
                    openModal("modalNovoEquipamentoTI");
                  }}
                >
                  Editar equipamento
                </MenuItem>
                <MenuItem
                  type="button"
                  onClick={() => {
                    setOpenMenuId(null);
                    setEquipamentoIdParaResponsavel(row.id);
                    openModal("modalAtribuirResponsavelTI");
                  }}
                >
                  Atribuir responsável
                </MenuItem>
                <MenuItem
                  type="button"
                  onClick={() => {
                    setOpenMenuId(null);
                    handleRemoveResponsavel(row.id);
                  }}
                >
                  Remover responsável
                </MenuItem>
                <DangerItem
                  type="button"
                  onClick={() => {
                    const ok = window.confirm("Desativar este equipamento?");
                    if (!ok) return;
                    setOpenMenuId(null);
                    handleDesativar(row.id);
                  }}
                >
                  Desativar equipamento
                </DangerItem>
              </Menu>
            )}
          </ActionsCell>
        ),
      },
    ],
    [handleDesativar, handleRemoveResponsavel, openMenuId, openModal]
  );

  return (
    <>
      <Container>
        <NavBar title="INVENTÁRIO T.I." setSideBar={handleOpenSidebar} />
        <BodyWrapper>
          <HeaderBar>
            <Title>Equipamentos</Title>
            <Badge>Em uso: {totalEmUso}</Badge>
            <Badge>Total: {totalFiltrado}</Badge>
            <FilterGroup role="tablist" aria-label="Filtrar equipamentos">
              <FilterButton
                type="button"
                role="tab"
                aria-selected={filtroUso === "em_uso"}
                $active={filtroUso === "em_uso"}
                onClick={() => setFiltroUso("em_uso")}
              >
                Em uso
              </FilterButton>
              <FilterButton
                type="button"
                role="tab"
                aria-selected={filtroUso === "todos"}
                $active={filtroUso === "todos"}
                onClick={() => setFiltroUso("todos")}
              >
                Todos
              </FilterButton>
            </FilterGroup>
            <FilterInput
              placeholder="Pesquisar por patrimônio, serial, equipamento, responsável..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </HeaderBar>

          <TableShell>
            <SortableTable
              columns={columns}
              data={filtered}
              isLoading={loading}
              loadingText="Carregando inventário..."
              onRowClick={(row) => {
                setSelectedId(row.id);
                openModal("modalDetalhesEquipamentoTI");
              }}
              rowCursor="pointer"
              emptyText="NENHUM EQUIPAMENTO ENCONTRADO"
              initialSort={{ key: "descricao", direction: "asc" }}
            />
          </TableShell>
        </BodyWrapper>
      </Container>

      {isModalOpen("sidebarInventarioTI") && (
        <SidebarInventarioTI
          selectedEquipamento={selectedEquipamento}
          onClose={() => closeModal()}
          onNovoEquipamento={() => openModal("modalNovoEquipamentoTI")}
          onNovoTipoAtivo={() => openModal("modalNovoTipoAtivoTI")}
          onOnboardColaborador={() => openModal("modalOnboardColaboradorTI")}
          onOffboardColaborador={() => openModal("modalOffboardColaboradorTI")}
          onGerarTermos={() => openModal("modalGerarTermosTI")}
        />
      )}

      {isModalOpen("modalOnboardColaboradorTI") && (
        <ModalOnboardColaborador
          onClose={() => closeModal()}
          equipamentos={equipamentos}
          onSaved={requestDados}
        />
      )}

      {isModalOpen("modalOffboardColaboradorTI") && (
        <ModalOffboardColaborador
          onClose={() => closeModal()}
          equipamentos={equipamentos}
          onOffboarded={requestDados}
        />
      )}

      {isModalOpen("modalGerarTermosTI") && (
        <ModalGerarTermos
          onClose={() => closeModal()}
          equipamentos={equipamentos}
          onSaved={requestDados}
        />
      )}

      {isModalOpen("modalNovoEquipamentoTI") && (
        <ModalNovoEquipamento
          onClose={() => {
            setEquipamentoParaEditar(null);
            closeModal();
          }}
          onCreated={requestDados}
          tiposAtivo={tiposAtivo}
          equipamento={equipamentoParaEditar}
        />
      )}

      {isModalOpen("modalAtribuirResponsavelTI") && (
        <ModalAtribuirResponsavel
          onClose={() => {
            setEquipamentoIdParaResponsavel("");
            closeModal();
          }}
          equipamentos={equipamentos}
          equipamentoId={equipamentoIdParaResponsavel || undefined}
          onAssigned={requestDados}
        />
      )}

      {isModalOpen("modalNovoTipoAtivoTI") && (
        <ModalNovoTipoAtivo
          onClose={() => closeModal()}
          onCreated={requestTiposAtivo}
        />
      )}

      {isModalOpen("modalDetalhesEquipamentoTI") && selectedEquipamento && (
        <ModalDetalhesEquipamento
          equipamento={selectedEquipamento}
          onClose={() => closeModal()}
        />
      )}
    </>
  );
}

